import Types from '../types';

const initialState = {};

export default (reducerState = initialState, action) => {
  switch (action.type) {
    case Types.SELECT_CHILD:
      return action.payload;
    default:
      return reducerState;
  }
};
